<script lang="ts" setup>
import type { Section } from '~/types'

interface Props extends Pick<Section, 'title' | 'theme' | 'subtitle' | 'expand' | 'buttons' | 'description'> {}
const props = defineProps<Props>()
</script>

<template>
  <div class="py-32 mx-auto max-w-6xl">
    <h1 />
    <HeadingText tag="h3">
      {{ props.title }}
    </HeadingText>
    <HeadingText tag="h5">
      {{ props.subtitle }}
    </HeadingText>
    <div
      class="htmldescription pb-12  max-w-4xl"
      data-allow-mismatch
      v-html="props.description"
    />
  </div>
</template>
